import { consentStatus, observeConsentStatusChange, THE_CONVERSATION_VENDOR_ID } from "../Didomi";
import { doNotPersistDeviceId, persistDeviceId } from "./browserEnvironment";
/**
 * Called to adjust whether or not to track the user's device id, based
 * on their latest consent status.
 */
export function updateDeviceIdPersistenceConsent(consent) {
    if (consent)
        persistDeviceId();
    else
        doNotPersistDeviceId();
}
/**
 * Configure Didomi to send events when the consent status changes.
 *
 * Status changes usually happen when the user clicks "Accept" on the
 * Didomi modal dialog in the middle of their screen. (If they dismiss it,
 * their status doesn't change, ie. remains false)
 */
export function startObservingConsentStatusChange() {
    observeConsentStatusChange(updateConsentStatus);
}
/**
 * Uses the Didomi API to find out the current consent status.
 *
 * This is triggered by status change events (see observeConsentStatusChange)
 * but is typically also called once at page load to get the initial status.
 */
export async function updateConsentStatus() {
    const userIsEligibleToTrack = await consentStatus({
        vendorId: THE_CONVERSATION_VENDOR_ID,
        purpose: "measure_content_performance",
    });
    updateDeviceIdPersistenceConsent(userIsEligibleToTrack);
}
